// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8297) return "static/chunks/8297.6e359d4f32c268ef.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"373":"2033a27d591b4622","1929":"7304dcd0e20bdce0","1985":"8d1e967bc1682050","3800":"2520cf2d4942011c","4414":"d12b30d071bc80c4","4550":"cdce6d99682a07ef","6567":"6ac7f5de47055afa","7761":"8a27216f2dd8a2a7","7909":"ff18e203ba608b58","9305":"a31f35d286ddb9c9","9974":"c7abea0508766980"}[chunkId] + ".js";
};